import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
  Grid
} from '@mui/material';
import { Search as SearchIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useState } from 'react';

const UserListToolbar = (props) => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    search: '',
  });
  const { search } = props;

  const handleChange = (event) => {
    setValues({
      [event.target.name]: event.target.value.toUpperCase()
    });
  };

  const handleSearch = async () => {
    await search(values.search);
  };

  const buttonNew = () => {
    navigate('/app/user', { replace: true });
  };

  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={buttonNew}
        >
          Adicionar Usuário
        </Button>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Box>
              <Grid container>
                <Grid item xs={12} md={11} lg={11}>
                  <TextField
                    fullWidth
                    label="Pesquisar"
                    name="search"
                    value={values.search}
                    onChange={handleChange}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon
                            fontSize="small"
                            color="action"
                          >
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Pesquisar"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} md={1} lg={1}>
                  <Button fullWidth style={{ padding: 15, float: 'right' }} color="primary" variant="contained" onClick={handleSearch}><SearchIcon /></Button>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

UserListToolbar.propTypes = {
  search: PropTypes.func.isRequired
};

export default UserListToolbar;
